export const SET_TOKEN = 'SET_TOKEN';
export const CLEAR_TOKEN = 'CLEAR_TOKEN';
export const SET_REFRESH_TOKEN = 'SET_REFRESH_TOKEN';

/**
 * @param {String} barearToken
 * @param {String} refershToken
 */
export function setToken(barearToken) {
  return {
    type: SET_TOKEN,
    barearToken,
  };
}
export function clearToken() {
  return {
    type: CLEAR_TOKEN,
  };
}

export function setRefreshToken(refreshToken) {
  return {
    type: SET_REFRESH_TOKEN,
    refreshToken,
  };
}
